import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 192 192"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Richtungspfeil", -1),
    _createElementVNode("path", {
      d: "m72.04 162.44 5.66-5.66-56.74-56.71h159.93v-8H20.87l56.89-56.68-5.65-5.67L8.42 93.17c-.75.75-1.18 1.77-1.18 2.83s.42 2.08 1.17 2.83l63.62 63.6Z",
      style: {"fill":"#2d2d2d"}
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "left"}) } }